// pop-up
$(document).ready(function () {
  $(".open1").click(function () {
    $(".pop-outer1").fadeTo(200, 1);
    $('body').addClass('pp_popup_open');
  });
  $(".close").click(function () {
    $(".pop-outer").fadeOut(200);
    $('body').removeClass('pp_popup_open');
  });
});

$(document).ready(function () {
  $(".open2").click(function () {
    $(".pop-outer2").fadeIn("slow");
    $('body').addClass('pp_popup_open');
  });
  $(".close").click(function () {
    $(".pop-outer").fadeOut("slow");
    $('body').removeClass('pp_popup_open');
  });
});

$(document).ready(function () {
  $(".open3").click(function () {
    $(".pop-outer3").fadeIn("slow");
    $('body').addClass('pp_popup_open');
  });
  $(".close").click(function () {
    $(".pop-outer").fadeOut("slow");
    $('body').removeClass('pp_popup_open');
  });
});